import * as MaterialUiIcons from "@mui/icons-material";
import * as React from "react";
import { FunctionComponent } from "react";
interface GatewayIconProps {
    color?: "inherit" | "primary" | "secondary" | "action" | "disabled" | "error";
}

const GatewayIcon: FunctionComponent<GatewayIconProps> = ({ color }) => <MaterialUiIcons.SettingsInputAntenna color={color}/>;

export default GatewayIcon;
